import AlertModal from "./AlertModal";
export * from './AlertModal';

export default AlertModal;